// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"95":"3309a8d8","290":"d26dead5","735":"61fc8679","915":"38c72176"}[chunkId] + ".css";
};